import { TFunction } from 'i18next';
import parsePhoneNumberFromString from 'libphonenumber-js';
import * as yup from 'yup';

export const validationChangePhoneSchema = (
  t: TFunction<'translation', undefined>,
) =>
  yup.object({
    phone: yup
      .string()
      .test(
        'phone-validators',
        t('userAuth.validationErrors.invalidPhoneNumber'),
        function (value) {
          const { email } = this.parent;
          if (!email) {
            if (!value || value === '') return false;
            const phoneNumber = parsePhoneNumberFromString(value, 'UA');
            return phoneNumber?.isValid() || false;
          }
          return true;
        },
      )
      .required(t('userAuth.validationErrors.required')),
  });
